// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"503":"ac30e5eb","806":"3b41e491"}[chunkId] + ".chunk.css";
};